import { useDispatch, useSelector } from 'react-redux'
import { ConfirmLoanDetailsInfo } from './ConfirmLoanDetailsInfo'

import { openLoans, markLoansChecked } from '../../../../actions/homeowner'
import { selectCurrentCELs as selectDictionary } from '../../../../store/selectors/home/dictionary'
import {
  selectCurrentCELs,
  selectUnverifiedCELs,
} from '../../../../store/selectors/home/loans'
import { selectShouldCheckLoanNumbers } from '../../../../store/selectors/home/homeowner'
import { useContext } from 'react'
import { AmplitudeContext } from '@homebot/shared-util-quartermaster'
import { AmplitudeEventConstants } from '@homebot/shared-util-quartermaster'
import { Loan } from '@homebot/shared-util-quartermaster/types'

// should NOT be displayed in Preview!
export const ConfirmLoanDetailsInfoWrapper = () => {
  const dispatch = useDispatch()
  const { ampli } = useContext(AmplitudeContext)
  const dictionary = useSelector(selectDictionary)
  const principalRaw = dictionary.principalPaidTotal()
  const interestRaw = dictionary.interestPaidTotal()
  const total = principalRaw + interestRaw

  const unverifiedLoans = useSelector(selectUnverifiedCELs)
  const shouldCheckNumbers = useSelector(selectShouldCheckLoanNumbers)

  const loans: Loan[] = useSelector(selectCurrentCELs)
  const emptyState = total === 0

  const handleConfirmLoans = () => {
    ampli?.clientCustomized({
      customization_type: AmplitudeEventConstants.CLIENT_CONFIRMED_LOAN,
    })

    dispatch(markLoansChecked(unverifiedLoans))
  }

  const handleUpdateLoanClick = () => {
    dispatch(openLoans())
    dispatch(markLoansChecked())
  }

  if (emptyState && !shouldCheckNumbers) {
    return null
  }

  return (
    <ConfirmLoanDetailsInfo
      loans={loans}
      handleUpdateLoanClick={handleUpdateLoanClick}
      handleConfirmLoans={handleConfirmLoans}
      shouldCheckNumbers={shouldCheckNumbers}
    />
  )
}
